import MicroModal from "micromodal";
import { Drawer } from "@/js/components/Drawer";
import { isDesktop } from "@/js/helpers/mediaQueryHelper";

const ID_SEARCH_MODAL = "modal--select-category";
const ID_HEADER_SEARCH_FORM = "headerSearchForm";
const ID_HEADER_SEARCH_SELECT_CATEGORY = "headerSearchSelectCategory";
const SELECTOR_HEADER_OPEN_SEARCH_BUTTON = ".js-header__open-search";
const SELECTOR_HEADER_MODAL_LINK_SELECT_CATEGORY = ".js-modal-link-select-category";

const IS_OPEN_CLASSNAME = "is-header-search-open";

class HeaderSearch {
    static attach() {
        /* eslint-disable-next-line no-unused-vars */
        const headerSearch = new HeaderSearch();
    }

    constructor() {
        this.isOpen = false;
        this.searchDrawer = new Drawer({
            open: ".js-header__open-search",
            close: ".js-header__close-search",
            drawer: ".js-header__search",
            showOverlay: false
        });
        this.searchForm = document.getElementById(ID_HEADER_SEARCH_FORM);
        this.selectedCategoryInput = document.getElementById(ID_HEADER_SEARCH_SELECT_CATEGORY);
        this.searchModal = document.getElementById(ID_SEARCH_MODAL);
        this.openModalButton = document.querySelector(SELECTOR_HEADER_OPEN_SEARCH_BUTTON);

        this.bindEvents();

        MicroModal.init();
        window.dispatchEvent(new Event("resize"));

        if (this.isSearching()) {
            this.openModalButton.click();
        }

        this.updateView();
    }

    bindEvents() {
        if (this.searchDrawer.drawerElement) {
            this.searchDrawer.drawerElement.addEventListener("drawer.open", () => {
                this.toggleIsOpen(true);
            });
            this.searchDrawer.drawerElement.addEventListener("drawer.close", () => {
                this.toggleIsOpen(false);
            });
        }

        [...document.querySelectorAll(SELECTOR_HEADER_MODAL_LINK_SELECT_CATEGORY)].forEach(
            (categoryLinkElement) => {
                categoryLinkElement.addEventListener("click", (event) => {
                    this.handleCategoryLinkClick(event.target);
                });
            }
        );

        window.addEventListener("resize", () => {
            this.handleWindowResize();
        });
    }

    handleCategoryLinkClick(categoryLinkElement) {
        const categoryId = categoryLinkElement.dataset.id ?? "";
        this.doSearch(categoryId);
    }

    handleWindowResize() {
        if (!isDesktop() && this.searchModal) {
            MicroModal.close(ID_SEARCH_MODAL);
        }
    }

    toggleIsOpen(isOpen) {
        this.isOpen = isOpen;
        this.updateView();
    }

    doSearch(categoryId) {
        this.selectedCategoryInput.value = categoryId;
        this.searchForm.submit();
    }

    updateView() {
        if (this.isOpen) {
            document.body.classList.add(IS_OPEN_CLASSNAME);
        } else {
            document.body.classList.remove(IS_OPEN_CLASSNAME);
        }
    }

    isSearching() {
        const { action } = this.searchForm || {};
        return window.location.href.indexOf(action) !== -1;
    }
}

export { HeaderSearch };
